var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.displayConditionOk
    ? _c("div", { staticClass: "form-group row" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              "b-form-checkbox",
              {
                class: _vm.getClass(),
                attrs: {
                  name: _vm.name,
                  checked: _vm.value,
                  "unchecked-value": "",
                  disabled: _vm.readonly,
                  required: _vm.required
                },
                on: { change: _vm.predicateChange },
                model: {
                  value: _vm.value,
                  callback: function($$v) {
                    _vm.value = $$v
                  },
                  expression: "value"
                }
              },
              [_vm._v("\n            " + _vm._s(_vm.label) + "\n        ")]
            )
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e340d43a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e340d43a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./_wwwsrc/js/Workflow/Components/Input/CheckBox.vue
// module id = 567
// module chunks = 0